import React, {FunctionComponent} from "react";
import * as msal from "@azure/msal-browser";
import {useDispatch, useSelector} from "react-redux";
import {msalConfig, scopes} from "./auth-config";
import {useTranslation} from "react-i18next";

import Empty from './assets/undraw_empty.svg';

// Redux methods
import {
	getGroupDriveFiles,
	login,
	logout,
	setAuthenticated,
	setGroupId,
	setLoading,
	setLoginError,
	setPublicClient,
	setToken,
	setUser,
} from "./store/actions/dataActions";
import {DetailsListDocuments} from "./DetailsListDocuments";
import {Image, ImageFit} from 'office-ui-fabric-react/lib/Image';
import {PrimaryButton} from "@fluentui/react";
import {classes} from "./App.styles";
import {ModalStack} from "./context/ModalContext";

export const App: FunctionComponent = () => {
	const dispatch = useDispatch();

	const isAuthenticated = useSelector(
		(state: any) => state.data.isAuthenticated
	);
	const groupId = useSelector((state: any) => state.data.groupId);
	const resourceDenied = useSelector((state: any) => state.data.resourceDenied);

	const {i18n, t} = useTranslation();

	React.useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		if (urlParams.get("lang") === "en") {
			i18n.changeLanguage("en");
		}

		let groupId = "";
		let clientId = "";
		let authority = "";
		if (process.env.NODE_ENV === 'development') {
			clientId = process.env["REACT_APP_CLIENT_ID"];
			authority = process.env["REACT_APP_AUTHORITY"];
			groupId = process.env["REACT_APP_AVENTO_TEST_1"];
		} else {
			clientId = urlParams.get("clientId");
			authority = urlParams.get("authority");
			groupId = urlParams.get("groupId")
		}

		window.addEventListener("hashchange", () => {
			clientId = urlParams.get("clientId");
			authority = urlParams.get("authority");
			dispatch(setGroupId(urlParams.get("groupId")));

			if (urlParams.get("lang") === "en") {
				i18n.changeLanguage("en");
			}
		});

		dispatch(setGroupId(groupId));

		(async () => {
			const pc = new msal.PublicClientApplication({
				auth: {
					clientId: clientId,
					authority: authority
				},
				cache: msalConfig.cache
			});
			dispatch(setPublicClient(pc));

			pc.handleRedirectPromise()
				.then((response) => {
					dispatch(setLoading(false));

					if (response) {
						dispatch(setUser(pc.getAllAccounts()[0]));

						dispatch(setAuthenticated(true));

						if (response.accessToken) {
							dispatch(setToken(response.accessToken));
						}
					}
				})
				.catch((error) => {
					console.error(error);
					dispatch(setLoginError(error));
					dispatch(logout());
				});

			if (pc.getAllAccounts()[0]) {
				dispatch(setUser(pc.getAllAccounts()[0]));
				dispatch(setAuthenticated(true));

				// Get document data
				if (groupId !== "") {
					dispatch(getGroupDriveFiles(scopes));
				}
			}
			// dispatch(tryLogin(scopes));
		})();

		// eslint-disable-next-line
	}, []);

	React.useEffect(() => {
		dispatch(getGroupDriveFiles(scopes));
	}, [groupId]);

	return (
		<div className="App">
			{isAuthenticated ? (
				resourceDenied ? (
					<div className={classes.loginWrapper}>
						<div className={classes.centerContent}>
							<img src={Empty} className={classes.errorImage} alt={"Empty icon"} />
							<h1 className={classes.errorTitle}>{t("missingAccess")}</h1>
						</div>
					</div>
				) : (
					<ModalStack>
						<DetailsListDocuments/>
					</ModalStack>
				)
			) : (
				<div className={classes.loginWrapper}>
					<PrimaryButton className={classes.centerContent} text="Log in" onClick={() => dispatch(login(scopes, "loginPopup"))} />
				</div>
			)}
		</div>
	);
};
